import t from"styled-components";const o=t.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
	align-items: start;
`;export{o as Container};
